/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import CiudadForm from './CiudadForm';
import * as validations from '../../validations/validations';
import * as ciudadActions from '../../actions/ciudadActions';
import * as regionActions from '../../actions/regionActions';
import * as paisActions from '../../actions/paisActions';
import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
import withRouter from '../common/withRouter';

 import $ from 'jquery';


class ManageCiudadForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			ciudad:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        
        let id=this.props.id;
        let pageInfo={ 
            page:'ciudad', 
            idioma:this.props.idioma     
        }; 
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
        this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
            this.setState({"permisos":pageInfoResponse.permisos, 
                     "strings":Object.assign({}, pageInfoResponse.strings)}); 
        }) 
        .catch(error=>{ 
            toastr.error(error); 
        }); 
        
        if(id && id>0 ){
            
           this.props.ciudadActions.getCiudad(id, this.props.user).then( ciudad=>{
               
               this.props.regionActions.getRegionComboByPais( this.props.user, ciudad.paisId).then( ()=>{ 
           
               }) 
                .catch(error=>{ 
                  toastr.error(error); 
                });
               
               this.setState({"ciudad":ciudad});
               
           })
            .catch(error=>{
              toastr.error(error);
            }); 
            
            
            
            
            
        }
        
         this.props.paisActions.getPaisCombo( this.props.user).then( ()=>{ 
           
           }) 
            .catch(error=>{ 
              toastr.error(error); 
            });
        
		
    }
    

    handleChange=(event, data)=> {

        let ciudad = this.state.ciudad;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        
        if(field=='paisId'){
            this.props.regionActions.getRegionComboByPais( this.props.user, value).then( ()=>{ 
           
               }) 
                .catch(error=>{ 
                  toastr.error(error); 
                });
            
        }
        
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		ciudad[field[0]]= value;
		else{
             if(!ciudad[field[0]]){
                    ciudad[field[0]]={}
                }
			ciudad[field[0]][field[1]]= value;
		}
        
		
        this.setState({"ciudad": ciudad});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let ciudad=this.state.ciudad;
              
        if(!validations.requerido(ciudad.regionId)){
            errors.regionId=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(ciudad.nombre)){
            errors.nombre=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.ciudadActions.save(this.state.ciudad, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            //this.props.history.push('/ciudads');
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <CiudadForm 
                    strings={this.state.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.ciudad}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    regionCombo={genericFormattedForDropdown(this.props.regionCombo)}
                    paisCombo={genericFormattedForDropdown(this.props.paisCombo)}   
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    //let id = ownProps.match.params.id;
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        form:state.form,
        regionCombo:state.regionCombo,
        paisCombo:state.paisCombo
    }

}

function mapDispatchToProps(dispatch){

	return {   
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        ciudadActions: bindActionCreators(ciudadActions, dispatch),
        regionActions: bindActionCreators(regionActions, dispatch),
        paisActions: bindActionCreators(paisActions, dispatch),
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageCiudadForm));